import React from "react";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Identification } from "./components/Identification";
import { Method } from "./components/Method";
import { Cases } from "./components/Cases";
import { Community } from "./components/Community";
import { Program } from "./components/Program";
import { Story } from "./components/Story";
import { Offer } from "./components/Offer";
import { Faq } from "./components/Faq";
import { Closing } from "./components/Closing";
import { WhatsAppInvite } from "./components/WhatsAppInvite";
import { Footer } from "./components/Footer";
export function App() {
  return <div className="min-h-screen w-full bg-ink font-sans text-white" data-id="element-0" data-mp="31ctflscv2296">
      <Nav data-id="element-1" data-mp="2wj8evsjvuu6a" />
      <main data-id="element-2" data-mp="2wip5x1c7ng4e">
        <Hero data-id="element-3" data-mp="2whxabqim5ie4" />
        <Identification data-id="element-4" data-mp="28ufpyg1ohml6" />
        <Method data-id="element-5" data-mp="28tmex2vosax8" />
        <Cases data-id="element-6" data-mp="28te3zgj4jfoo" />
        <Community data-id="element-7" data-mp="28suv0pbgc1ms" />
        <Program data-id="element-8" data-mp="28sbe9bxjfjac" />
        <Story data-id="element-9" data-mp="23vcmh01cjofb" />
        <Offer data-id="element-10" data-mp="23vupcfiil0w7" />
        <Faq data-id="element-11" data-mp="23u9v6r043jyv" />
        <Closing data-id="element-12" data-mp="23utcq6luo6cd" />
        <WhatsAppInvite data-id="element-13" data-mp="23t8hsfvmildz" />
      </main>
      <Footer data-id="element-14" data-mp="3ikh8gaq64uzi" />
    </div>;
}